
  function initCarousel(elm, opts) {
    // console.log('elm', elm)
    var final_obj;

    var default_opts = {
      items:1,
      loop: false,
      center: true,
      stagePadding: 0,
      nav: false,
      dots: false
    }

    if(opts && typeof opts === 'object') {
      // console.log('a')
     final_obj = jQuery.extend({}, default_opts , opts)
    }
    else {
      // console.log('b')
      final_obj = default_opts
    }
    // console.log('final_obj', final_obj)

    if(jQuery(window).width() < 768) {
      jQuery(elm).each(function(i, owl) {
        jQuery(owl).owlCarousel(final_obj);
        jQuery(owl).addClass('on');
        jQuery(owl).removeClass('off');
      })
    }
    else {
      jQuery(elm).owlCarousel('destroy');
      jQuery(elm).removeClass('on');
      jQuery(elm).addClass('off');
    }

  }

  function initReveal(elms, opts) {
    // console.log('elm', elm)
    var final_obj;

    var default_opts = {};

    if(opts && typeof opts === 'object') {
      // console.log('a')
     final_obj = jQuery.extend({}, default_opts , opts)
    }
    else {
      // console.log('b')
      final_obj = default_opts
    }
    // console.log('final_obj', final_obj)

    ScrollReveal({ mobile: false }).reveal(elms,  opts);

  }

  function hasSpeechRecognition() {
    let returning_bol;
    if ('webkitSpeechRecognition' in window) {
        // speech recognition API supported
        returning_bol = true;
    } else {
        // speech recognition API not supported
        returning_bol = false;
    }
    return returning_bol;
  }

  function str_slug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeiiiioooouuuunc------";

    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

function checkSelectedMagTimestamp() {
  let selected_magasin_timestamp = localStorage.getItem('selected_magasin_timestamp');
  let home_magasin_id = localStorage.getItem('home_magasin_id');
  

  if(selected_magasin_timestamp != null && home_magasin_id != null) {
    let saveMagasinSession = route('select.magasin.session').template;
    saveMagasinSession = saveMagasinSession.replace('{magasinId}', home_magasin_id)

      let dateNow = dayjs( Date.now() );
      let dayTimestamp = dayjs( parseInt(selected_magasin_timestamp) );

      let diff = dayTimestamp.diff( dateNow , "hours")

      if(diff >= 2) {
        $.ajax({
            type:'GET',
            url: saveMagasinSession, // ajaxGetResult défini dans le blade
            dataType: 'json'
        })
        .done(function(data) {
          //console.log('le magasin ayant pour id ' + home_magasin_id + ' a été rafraichi coté session')
        })
        .fail(function(jqXHR) {
          // Affichage des erreurs
          //console.log('error', jqXHR)
        });
      }
  }
}


module.exports = {initCarousel, initReveal, hasSpeechRecognition, str_slug,  checkSelectedMagTimestamp}
